const KEY = "ModelCollectionAttribution";
const TTL_MS = 30 * 24 * 60 * 60 * 1000;

/** Запоминает подборку, которую смотрел пользователь (окно атрибуции — 30 дней). */
export function setCollectionAttribution(hash: string): void {
    if (!import.meta.client) return;
    try {
        localStorage.setItem(KEY, JSON.stringify({ hash, ts: Date.now() }));
    } catch {
        // localStorage недоступен (приватный режим) — атрибуция просто не сохранится
    }
}

export function getCollectionAttribution(): string | null {
    if (!import.meta.client) return null;
    try {
        const raw = localStorage.getItem(KEY);
        if (!raw) return null;
        const { hash, ts } = JSON.parse(raw);
        if (!hash || Date.now() - ts > TTL_MS) return null;
        return hash;
    } catch {
        return null;
    }
}
